import React from "react";
import List from "@commonComponents/List";

const ConsigneeDetail = ({dataSource,renderForm,...rest}) => {
  const renderItem=(item)=>renderForm({
    dataSource:item,
    key:item.id,
    ...rest
  })

  
  return <List className="responsiveGridCss"  dataSource={dataSource} renderItem={renderItem}/>
      
}

export default React.memo(ConsigneeDetail)
